<template>
  <div class="container-invite-history">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k033') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="time-box">
        <div class="time" @click="handleTimePop">
          <span>{{ handleMoment(chooseTime, 'YYYY-MM') }}</span>
          <img class="time-img" src="@/assets/packageAssets/common/arrow06.png" alt="" />
        </div>
        <CStatus :activeStatu="activeStatu" :statuslist="statusList" @selectStatus="selectStatus" />
      </div>
      <div class="list">
        <div class="list-item" v-for="item in hisData" :key="item.id">
          <div class="status">
            <div class="tit" v-if="item.billCategoryType == 14">
              {{ $t('lang.BaseCommon.k031') }}
              <span v-if="item.remark">{{ item.remark }}%</span>
            </div>
            <div class="tit" v-else-if="item.billCategoryType == 15">{{ $t('lang.BaseCommon.k051') }}</div>
            <div class="tit" v-else-if="item.billCategoryType == 16">{{ $t('lang.InviteHistory.k001') }}</div>
            <div class="tit" v-else-if="item.billCategoryType == 18">{{ $t('lang.BaseCommon.k084') }}</div>
            <div class="tit" v-else-if="item.billCategoryType == 19">{{ $t('lang.InviteHistory.k002') }}</div>
            <div class="tit" v-else>{{ $t('lang.BaseCommon.k079') }}</div>
            <div class="beans">
              {{ item.changeAmount }}
              <img :src="getMatchImg('beans')" alt="" />
            </div>
          </div>
          <div class="times">
            <div v-if="item.billCategoryType == 15 || item.billCategoryType == 18 || item.billCategoryType == 19">{{ item.fromName }}</div>
            <div v-else>{{ handleMoment(item.billTime, 'DD/MM') }}</div>
            <div>{{ handleMoment(item.createTime, 'MM-DD HH:mm:ss') }}</div>
          </div>
        </div>
        <div v-if="hisData && !hisData.length" class="van-list__finished-text" style="margin-top: 150px">{{ $t('lang.BaseCommon.k087') }}</div>
      </div>
    </div>
    <CTime :showPop="showPop" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import CStatus from '@/components/CStatus'
import CTime from '@/components/CTime'
import { apiFetchInviteHistory } from '@/api/imee'

export default {
  components: { CTime, CStatus },
  props: {},
  data() {
    let query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      walletType: query.walletType || 1, // 0是主播 1是代理
      showPop: false,
      chooseTime: new Date(),
      hisData: [],

      activeStatu: this.$t('lang.BaseCommon.k003'), // 默认状态
      statusList: [
        {
          id: '1',
          text: this.$t('lang.BaseCommon.k003'),
        },
        {
          id: '14',
          text: this.$t('lang.BaseCommon.k031'),
        },
        {
          id: '16',
          text: this.$t('lang.InviteHistory.k001'),
        },
        {
          id: '15',
          text: this.$t('lang.BaseCommon.k051'),
        },
        {
          id: '18',
          text: this.$t('lang.BaseCommon.k084'),
        },
        {
          id: '19',
          text: this.$t('lang.InviteHistory.k002'),
        },
        {
          id: '17',
          text: this.$t('lang.BaseCommon.k079'),
        },
      ],
    }
  },
  created() {
    this.historyList()
  },
  mounted() {},
  methods: {
    handleBack() {
      this.$router.replace({
        path: '/invite',
        query: {
          tab: 2,
        },
      })
    },
    historyList(val) {
      let params = {
        walletType: this.walletType,
        billCategoryType: val || '',
        limit: 500,
        offset: 0,
        ...this.getMonthStartAndEnd(this.chooseTime),
      }
      apiFetchInviteHistory(params).then((res) => {
        if (res) {
          this.hisData = res
        }
      })
    },

    // 打开日期选择
    handleTimePop() {
      this.showPop = true
    },

    // 选择当前的日期
    handleCurrentDate(val) {
      this.chooseTime = val
      this.historyList()
    },

    // 关闭弹框
    closePop() {
      this.showPop = false
    },

    // 选择状态
    selectStatus(val, item) {
      this.activeStatu = val

      if (item.id === '1') {
        this.historyList('')
        return
      }

      if (item.id) {
        this.historyList(`${item.id}`)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container-invite-history {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  .main {
    margin-top: 20px;
  }
  .time-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    background: #f9f9fb;
    padding: 0 14px;
  }
  .time {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 108px;
    height: 30px;
    background: #ffffff;
    border-radius: 6px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-family: 'Inter-Medium', 'Inter-Regular';
    font-weight: 500;
    color: #666666;
    .time-img {
      position: absolute;
      right: 5px;
      width: 16px;
      height: 16px;
    }
  }

  .list {
    width: 100%;
    padding: 0 24px;
    .list-item {
      width: 100%;
      height: 57px;
      margin-top: 19px;
      display: flex;
      flex-direction: column;
      font-family: 'Inter-Regular';
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 17px;
      font-style: normal;
      border-bottom: 1px solid #f2f2f8;
      .status,
      .times {
        display: flex;
        justify-content: space-between;
      }
      .status {
        font-size: 14px;
        .beans {
          display: flex;
          align-items: center;
          > img {
            width: 14px;
            height: 14px;
            margin: 0 1px;
          }
        }
      }
      .times {
        margin-top: 5px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
::v-deep .van-nav-bar__left .tit-left {
  color: #000 !important;
  font-family: 'F-Medium';
  font-size: 17px !important;
}

::v-deep .van-progress {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  border-radius: 10px;
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .main {
    .time-box {
      .time {
        margin-left: 10px;
      }
    }
  }
}
</style>
